import React from 'react'
import { useTranslation } from "react-i18next";
import apiClient from '../../../utils/apiClient';

const Tr = (props) => {
    const { t } = useTranslation();

    const user = props.user;
    const userMailHandler = props.userMailHandler;

    const handleDownloadHistory = async () => {
        try {
            const response = await apiClient.downloadUserGachaHistory(user.id);
            if (!response.ok) {
                alert(t('common.error'));
                return;
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `user${user.id}_gacha_history.csv`);
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 100);
        } catch (err) {
            alert(t('common.error'));
        }
    };

    return (
    <>
        <tr>
            <td>{user.id}</td>
            <td>{user.email}</td>
            <td>{user.last_name}{user.first_name}</td>
            <td>
                {Number(user.identity_verified) === 1 ? t('user.identity_verified') : t('user.identity_unverified')}
                {/* 実名認証の氏名・身分証番号は内容を表示しない（登録があれば *** ） */}
                {user.identity_name && <div className="user-identity-masked">{t('user.identity_name')}: {user.identity_name}</div>}
                {user.identity_number && <div className="user-identity-masked">{t('user.identity_number')}: {user.identity_number}</div>}
            </td>
            <td>{user.identity_verified_at || '-'}</td>
            <td>{Number(user.point).toLocaleString()}</td>
            <td>{Number(user.total_payment_amount).toLocaleString()}</td>
            <td>
                <button className="user-list-content-table-button" onClick={() => userMailHandler(user.id, user.email)}>{t('tr.point')}</button>
                <button className="user-list-content-table-button user-list-content-table-button-history" onClick={handleDownloadHistory}>{t('tr.gachaHistory')}</button>
            </td>
        </tr>
    </>
    )
}

export default Tr